import React, { useContext, useCallback, useState } from 'react'

import { useSelector } from 'react-redux'
import { faPlus } from '@fortawesome/pro-solid-svg-icons'
import { isFunction } from 'lodash'

import { selectUser } from '../../../reducers/UserReducer'
import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'
import IconButton from '../../../Components/antd/Buttons/IconButton'
import { QuotaFormModalContext, Types } from '../../../Providers/Forms/QuotaForm/QuotaFormModalProvider'
import { PeriodTypes } from '../../../utils/timePeriods'
import DisplacementDatePicker from '../../../Components/institution/Quotas/shared/DisplacementDatePicker'
import { Quota } from '../../../utils/entities/quota'
import QuotasTableSettings from './QuotasTableSettings'

import '../../../Components/institution/Quotas/assets/quotas.scss'

const PlacesHeader = ({
  addDisabled, period, date, overlaySettings,
  onPeriodChange, onDateChange, onOverlaySettingsChange, onQuotaChange, onResetGravity
}) => {
  const { setFormHandler } = useContext(QuotaFormModalContext)

  const t = useSelector(selectTranslate)
  const user = useSelector(selectUser)

  const [isSettingsVisible, setIsSettingsVisible] = useState(false)
  const [isOverlayMenuVisible, setIsOverlayMenuVisible] = useState(false)

  const hideOverlayMenuAndDo = useCallback(callback => isVisible => {
    if (isFunction(callback)) {
      callback(isVisible)
    }
    if (isOverlayMenuVisible) {
      setIsOverlayMenuVisible(false)
    }
  }, [isOverlayMenuVisible])

  const handleAddClick = useCallback(() => {
    setFormHandler(handler => ({
      ...handler,
      data: new Quota({
        startDate: period?.startDate,
        endDate: period?.endDate,
        school: user.school,
        total: 0,
        isDesiderata: true
      }),
      callback: onQuotaChange,
      type: Types.DESIDERATA
    }))
  }, [user.school, period, onQuotaChange])

  return (
    <div className='places-tables-settings-header flex-row mb-8'>
      <IconButton
        key='settings'
        icon={faPlus}
        disabled={addDisabled}
        text={t('quota_table_menu.buttons.add_quota')}
        onClick={handleAddClick}
      />

      <div className='h-spacing' />

      <QuotasTableSettings
        overlayPrefix='places_view.overlay_option.'
        visible={isSettingsVisible}
        period={period}
        overlaySettings={overlaySettings}
        overlayMenuVisible={isOverlayMenuVisible}
        onClick={setIsSettingsVisible}
        onVisibleChange={hideOverlayMenuAndDo(setIsSettingsVisible)}
        onPeriodChange={onPeriodChange}
        onOverlaySettingsSelection={onOverlaySettingsChange}
        onOverlayMenuVisibleChange={setIsOverlayMenuVisible}
        onResetGravity={onResetGravity}
      />

      <div className='flex-fill' />

      <DisplacementDatePicker
        date={date}
        timePeriod={PeriodTypes.WEEK}
        onDateChange={onDateChange}
      />
    </div>
  )
}

export default PlacesHeader
